import * as types from './types.action';

export function setUpSellingModalCancelledSuccess(modalCancelled) {
  return {
    type: types.SET_UPSELLING_MODAL_CANCELLED_SUCCESS,
    modalCancelled
  };
}

export function setUpSellingModalCancelled(modalCancelled) {
  return dispatch => dispatch(setUpSellingModalCancelledSuccess(modalCancelled));
}



// WEBPACK FOOTER //
// ./actions/upSelling.action.js